import React from 'react';
import { Typography } from '@mui/material';

// The one code a return/exchange line shows. The API picks it (Product#display_barcode):
// EAN first, System Barcode when there is no EAN. Renders nothing when a product has neither.
export default function ItemBarcode({ code, fontSize = '0.65rem' }) {
  if (!code) return null;
  return (
    <Typography
      data-testid="item-barcode"
      fontSize={fontSize}
      color="#64748B"
      sx={{ overflowWrap: 'anywhere' }}
    >
      Barcode: {code}
    </Typography>
  );
}
